import {
  environmentConstants,
  validEnvironments,
  type Environment,
} from '@/constants/Environments';

export function isEnvironment(environment: Environment | string): environment is Environment {
  return validEnvironments.includes(environment.toLowerCase() as unknown as Environment);
}

export const getEnvironmentConstants = (environment: Environment | '' = '') => {
  if (typeof environment !== 'string') {
    console.warn('getEnvironmentConstants: environment is not a string; using prod instead.');
    return environmentConstants.prod;
  }

  const possibleEnvironmentName = environment.toLowerCase();
  if (
    isEnvironment(possibleEnvironmentName) &&
    typeof environmentConstants[possibleEnvironmentName] !== 'undefined'
  ) {
    return environmentConstants[possibleEnvironmentName];
  }

  console.warn(
    'getEnvironmentConstants: environment is not a valid environment; using prod instead.',
  );
  return environmentConstants.prod;
};
